import React from 'react'

const SvgCopyFilled = (props: React.SVGProps<SVGSVGElement>) => (
  <svg width='1em' height='1em' viewBox='0 0 24 24' {...props}>
    <path d='M16 6h-6c-1.336 0-2.002.667-2 2v10H4c-1.333 0-2-.667-2-2V4c0-1.333.667-2 2-2h10c1.333 0 2 .667 2 2v2zm6 2v12c0 1.333-.667 2-2 2H10V8h12z' />
  </svg>
)

export default SvgCopyFilled
